import { c as _c } from "react/compiler-runtime";
import { getValuesForSelectedOptions } from 'commons/productUtils';
import { useCallback } from 'react';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import useProductFavoriteV2 from '../useProductFavoriteV2';
const getEventData = ({
  product,
  price,
  optionPrice,
  options,
  selectedOptions,
  isFavorited = false,
  isDecideLater = false
}) => {
  const {
    fabric
  } = getValuesForSelectedOptions(options, selectedOptions);
  return {
    fabric_id: fabric?.id || 0,
    fabric_name: isDecideLater ? 'Decide Later' : fabric?.value || '',
    fabric_color: fabric?.color || '',
    favorited: isFavorited,
    product_id: product.id,
    product_name: product.name,
    price: price.final_price + optionPrice,
    full_price: price.original_price + optionPrice,
    product_family: product.family?.name,
    product_type: product.type.name
  };
};
const usePDPFullScreenClickEvent = (basicDetails, optionData, priceData) => {
  const $ = _c(10);
  const {
    isFavorited
  } = useProductFavoriteV2();
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  let t0;
  if ($[0] !== basicDetails || $[1] !== isFavorited || $[2] !== optionData.options || $[3] !== optionData.selectedOptions || $[4] !== pdpSelectedCustomizerTab || $[5] !== priceData?.optionPrice || $[6] !== priceData?.price) {
    t0 = () => {
      getEventData({
        isFavorited,
        product: basicDetails,
        price: priceData?.price,
        optionPrice: priceData?.optionPrice,
        options: optionData.options,
        selectedOptions: optionData.selectedOptions,
        isDecideLater: pdpSelectedCustomizerTab === "decide-later"
      });
    };
    $[0] = basicDetails;
    $[1] = isFavorited;
    $[2] = optionData.options;
    $[3] = optionData.selectedOptions;
    $[4] = pdpSelectedCustomizerTab;
    $[5] = priceData?.optionPrice;
    $[6] = priceData?.price;
    $[7] = t0;
  } else {
    t0 = $[7];
  }
  priceData?.price;
  priceData?.optionPrice;
  const fullScreenClickEvent = t0;
  let t1;
  if ($[8] !== fullScreenClickEvent) {
    t1 = {
      fullScreenClickEvent
    };
    $[8] = fullScreenClickEvent;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
};
export default usePDPFullScreenClickEvent;